import Start from './Start';
import Stop from './Stop';

export default {
    Start,
    Stop,
};
